import { smScreen } from '../../lib/constants';
import { useMediaQuery } from '../../hooks/useMediaQuery';

export const Footer = () => {
  const isMobile = useMediaQuery(smScreen);
  const classes = useStyles();

  if (isMobile) return null;

  return (
    <footer className="fixed bottom-0 bg-background-light dark:bg-background-dark inline-flex flex-wrap items-start px-4 border-t border-border-light dark:border-border-dark z-[899] w-full">
      <a
        href="http://www.tangerineglobal.com/contact"
        target="_new"
        className={classes.link}
      >
        Contact Us
      </a>
      <a
        href="http://www.tangerineglobal.com/company"
        target="_new"
        className={classes.link}
      >
        About Us
      </a>
      <a
        href="http://www.tangerineglobal.com/terms-of-use"
        target="_new"
        className={classes.link}
      >
        Terms Of Use
      </a>
      <a
        href="http://www.tangerineglobal.com/privacy-policy"
        target="_new"
        className={classes.link}
      >
        Privacy Policy
      </a>

      <span className="ml-auto p-4 mr-[80px]">
        &copy; {new Date().getFullYear()}{' '}
        <a href="http://www.tangerineglobal.com" target="_new">
          Tangerine Global, LLC.
        </a>
      </span>
    </footer>
  );
};

const useStyles = () => ({
  link: 'p-4 text-[12px] uppercase',
});
